export enum FeatureFlagsEnum {
  securityHPIDEmail = 'security-hp-id-email',
  securityHPIDPassword = 'security-hp-id-password',
  securityHPIDPhone = 'security-hp-id-phone',
  originalFeedbackExperience = 'original-feedback-experience'
}

export enum FormTypesEnum {
  Email = 'email',
  Phone = 'phone',
  Password = 'password',
  UserName = 'username',
  Mfa = 'mfa'
}
